import styled from '@emotion/styled';
import { Link as ReactLink } from 'react-router-dom';

import { Button } from 'components/buttons';
import IconCheckCircle from 'components/icons/checkCircle';
import { Path } from 'components/icons/styles';
import { InputRoot } from 'components/inputs/input/styles';

export const Section = styled.div((props) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 8,

  width: 290,
  // @ts-ignore
  [InputRoot]: {
    width: 290,
  },
}));

export const SectionRow = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: 30,
});

export const PanelButtonsWrapper = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: 20,
}));

export const PanelButton = styled(Button)(() => ({
  minWidth: 132,
  whiteSpace: 'nowrap',
}));

export const Label = styled.div((props) => ({
  fontSize: 13,
  lineHeight: '16px',
  fontWeight: 400,
  fontFamily: props.theme.fonts.primary,
}));

export const Optional = styled(Label)((props) => ({
  fontStyle: 'italic',
  color: props.theme.colors.inactive,
}));

export const Row = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 20,
}));

export const Controls = styled.div(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: 16,
  marginTop: -8,
  marginBottom: -8,
}));

export const FormContainer = styled.div(() => ({
  padding: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
}));

export const CopyButton = styled(Button)((props) => ({
  minWidth: 0,
  width: 73,
  paddingTop: 4,
  paddingBottom: 4,
  // @ts-ignore
  [Path]: {
    fill: props.theme.colors.accent,
  },
}));

export const Link = styled(ReactLink)((props) => ({
  color: props.theme.colors.accent,
}));

export const CheckIcon = styled(IconCheckCircle)((props) => ({
  overflow: 'visible',
  color: props.theme.colors.text.accent,
}));

export const TitanDataStatusBadge = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  fontSize: 12,
  fontWeight: 400,
  border: '0.5px solid rgba(98, 118, 160, 0.30);',
  backgroundColor: props.theme.colors.highlight,
  boxShadow: '0px 3px 12px 0px rgba(242, 247, 255, 0.05)',
  borderRadius: 5,
  padding: '3px 6px',
  whiteSpace: 'nowrap',
}));

export const ErrorMessage = styled.div((props) => ({
  color: props.theme.colors.error.main,
  fontSize: 12,
  fontWeight: 500,
  marginTop: 8,
}));
